import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    alias: 'playground',
    description:
      'Demonstrates opening the assistant slideout both via a row-click-' +
      'driven action and via a direct/fixed action',
    icon: 'flask',
    name: 'Playground',
    scenarioVariables: [],
    sessionVariables: [],
    supportsScenarios: false,
  },
  type: core.quiver.Resource.Type.App,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.App>
